import { render, staticRenderFns } from "./Arrecadacao.vue?vue&type=template&id=600c844f&scoped=true"
import script from "./Arrecadacao.vue?vue&type=script&lang=js"
export * from "./Arrecadacao.vue?vue&type=script&lang=js"
import style0 from "./Arrecadacao.vue?vue&type=style&index=0&id=600c844f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600c844f",
  null
  
)

export default component.exports